export default {
  name: 'Canada',
  phonePattern: '4165551234',
  postalCodePattern: 'A1A1A1',
  singlePostalCode: '',
  postalCodeRegex: '([ABCEGHJKLMNPRSTVXY]\\d)([ABCEGHJKLMNPRSTVWXYZ]\\d){2}',
  language: '',
  dobFormat: 'YY-MM-DD',
  currency: 'cad',
  provinces: [{
    name: 'Alberta',
    ISOCode: 'CA-AB'
  }, {
    name: 'British Columbia',
    ISOCode: 'CA-BC'
  }, {
    name: 'Manitoba',
    ISOCode: 'CA-MB'
  }, {
    name: 'New Brunswick',
    ISOCode: 'CA-NB'
  }, {
    name: 'Newfoundland',
    ISOCode: 'CA-NF'
  }, {
    name: 'Northwest Territories',
    ISOCode: 'CA-NT'
  }, {
    name: 'Nova Scotia',
    ISOCode: 'CA-NS'
  }, {
    name: 'Nunavut',
    ISOCode: 'CA-NU'
  }, {
    name: 'Ontario',
    ISOCode: 'CA-ON'
  }, {
    name: 'Prince Edward Island',
    ISOCode: 'CA-PE'
  }, {
    name: 'Quebec',
    ISOCode: 'CA-PQ'
  }, {
    name: 'Saskatchewan',
    ISOCode: 'CA-SK'
  }, {
    name: 'Yukon',
    ISOCode: 'CA-YT'
  }]
}



// WEBPACK FOOTER //
// ./src/locales/countries/CA.js